import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { SurveyPage } from './survey';
import { SignaturePadModule } from 'angular2-signaturepad';
import { ComponentsModule } from '../../components/components.module';
import { SigPadComponent } from '../../components/sig-pad/sig-pad';

@NgModule({
  declarations: [
    SurveyPage
  ],
  imports: [
    IonicPageModule.forChild(SurveyPage),
    SignaturePadModule,
    ComponentsModule
  ],
})
export class SurveyPageModule {}



// WEBPACK FOOTER //
// ./src/pages/survey/survey.module.ts